<template>
  <v-container></v-container>
</template>

<script>
export default {
  name: 'RedirectPage',

  created() {
    this.$nextTick(() => {
      this.$router.push({name: this.$route.params.routenm, params: {id: this.$route.params.id}})
    })
  }
}
</script>
